import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[fileDragDrop]'
})
export class FileDragDropDirective {
  @Output() filesChangeEmiter = new EventEmitter<FileList>();

  @HostListener('drop', ['$event'])
  public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    if (evt.dataTransfer && evt.dataTransfer.files.length > 0) {
      this.filesChangeEmiter.emit(evt.dataTransfer.files);
    }
  }

  @HostListener('dragover', ['$event'])
  public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }
}